export const remainingEn = {
  // FAQ — remaining Q&A
  'faq.q.wishlists': 'How do wishlists work?',
  'faq.a.wishlists':
    'Add items, set sat prices, share your link. Supporters fund items via Lightning — or buy the product from Amazon/other shops when you attach a product URL.',
  'faq.q.productLinks': 'Can I add Amazon or clothing product links?',
  'faq.a.productLinks':
    'Yes. On your project, open a wishlist and tap “Add product from link”. Paste any product URL (Amazon, Nike, Etsy, Shopify stores, etc.). KATOA reads the title/image when possible; supporters get a Buy button to purchase and ship to you, plus Fund with sats.',
  'faq.q.anonymousGifts': 'Can I receive gifts anonymously?',
  'faq.a.anonymousGifts':
    'Yes. Lightning payments can be pseudonymous. Public wishlists show only what you choose to share.',
  'faq.q.p2p': 'What is peer-to-peer commerce?',
  'faq.a.p2p': 'Money flows directly from supporter to creator wallet — KATOA never custodies funds.',
  'faq.q.zkp': 'What are zero-knowledge proofs?',
  'faq.a.zkp':
    'Cryptographic proofs that verify facts without revealing underlying data — part of our privacy roadmap.',
  'faq.q.lightningWallet': 'How do I set up a Lightning wallet?',
  'faq.a.lightningWallet':
    'Use Phoenix, Wallet of Satoshi, Muun, or self-hosted LND/CLN. Add your Lightning address in Settings.',
  'faq.q.openSource': 'Is KATOA open source?',
  'faq.a.openSource': 'Yes — MIT licensed. Audit, fork, or self-host the frontend.',
  'faq.q.howSecure': 'How secure is KATOA?',
  'faq.a.howSecure':
    'We never hold your keys or funds. Industry-standard encryption for account data. Read the full model on the Security page.',
  'faq.q.loseAccess': 'What if I lose access?',
  'faq.a.loseAccess':
    'Email accounts can use password recovery. If you linked Nostr in Settings, your extension keys still control Nostr identity — app login uses email/Google until secure Nostr auth ships.',
  'faq.q.whoHoldsSats': 'Who holds the sats during a gift?',
  'faq.a.whoHoldsSats':
    'Nobody intermediate. You pay the creator’s Lightning address or on-chain wallet. KATOA does not operate a hot wallet for user funds.',
  'faq.q.verifyFees': 'How do I verify 0% fees?',
  'faq.a.verifyFees':
    'There is no platform take rate in product design. Compare legacy fee math on Why KATOA, audit the open-source frontend, and watch sats land in the creator wallet you control.',
  'faq.q.exploreReal': 'Are explore projects real?',
  'faq.a.exploreReal':
    'Some catalog entries are labeled Demo for product preview. Live creator accounts use real payment destinations once wallets are configured. Demo badges appear on sample content.',
  'faq.q.roadmap': 'What is on the public roadmap?',
  'faq.a.roadmap':
    'Shipped work and next priorities are listed on the in-app roadmap and in docs/ROADMAP.md on GitHub.',

  // Press kit
  'press.metaTitle': 'Press kit',
  'press.metaDesc': 'KATOA press kit — one-liner, boilerplate, logos, and links for journalists and partners.',
  'press.title': 'Press kit',
  'press.subtitle': 'Assets and copy for media, partners, and meetup hosts.',
  'press.onelinerHeading': 'One-liner',
  'press.oneliner':
    'KATOA is a zero-fee, non-custodial Bitcoin creator platform — wishlists and Lightning gifts so creators keep 100%.',
  'press.boilerplateHeading': 'Boilerplate',
  'press.boilerplate':
    "KATOA (Keep All That's Owed Always) is an open-source, zero-fee creator platform built on Bitcoin Lightning and Nostr. Creators publish wishlists and receive support directly to wallets they control. KATOA never takes a platform cut and never holds user funds. Part of the Give A Bit family.",
  'press.logos': 'Logos',
  'press.links': 'Links',
  'press.copy': 'Copy',
  'press.copied': 'Copied',
  'press.copyFailed': 'Copy failed',
  'press.pitchPage': 'Pitch page',
  'press.security': 'Security & custody',
  'press.logoAlt': 'KATOA logo',

  // Meetup kit
  'meetup.metaTitle': 'Meetup kit',
  'meetup.metaDesc': 'Talk track, QR, and demo script for KATOA at Bitcoin meetups.',
  'meetup.title': 'Meetup kit',
  'meetup.subtitle': 'Run a clear 60-second demo at any Bitcoin or mutual-aid meetup.',
  'meetup.scriptHeading': 'Demo script',
  'meetup.script':
    '60-second KATOA demo\n1. Open katoa.org — zero fees, non-custodial.\n2. Explore → open a Demo wishlist (labeled).\n3. Show Send gift → QR / Lightning flow.\n4. Emphasize: sats go to creator wallets; KATOA takes 0%.\n5. CTA: create account, add Lightning address, share link.',
  'meetup.copyScript': 'Copy script',
  'meetup.copied': 'Copied',
  'meetup.copyFailed': 'Copy failed',
  'meetup.pointPhones': 'Point phones here',
  'meetup.qrAlt': 'QR code to katoa.org',
  'meetup.pressKit': 'Press kit',
  'meetup.pitchPage': 'Pitch page',

  // Case studies
  'cases.metaTitle': 'Case studies',
  'cases.metaDesc': 'How creators use KATOA — zero-fee wishlists and Lightning support.',
  'cases.title': 'Case studies',
  'cases.subtitle': 'Patterns that work. Some stories use demo catalogs until live pilots publish.',
  'cases.viewExample': 'View example',
  'cases.1.title': 'Community skate park (demo)',
  'cases.1.vertical': 'Sports / youth',
  'cases.1.result': 'Wishlist + Lightning gifts · 0% platform fee',
  'cases.1.body':
    'A public demo wishlist shows how fans fund gear and construction items — or buy products via Amazon links — without a 10–20% cut.',
  'cases.2.title': 'Independent creator tip jar',
  'cases.2.vertical': 'Model / lifestyle',
  'cases.2.result': 'Direct sats · wishlist outfits & gear',
  'cases.2.body':
    'Creators list product links and goals. Supporters fund in Bitcoin or purchase items. No bank middleman required to start.',
  'cases.3.title': 'Coach / meal planner launch',
  'cases.3.vertical': 'Education & food',
  'cases.3.result': 'Template-driven wishlist',
  'cases.3.body':
    'Templates seed camera gear, print runs, and program launches. Fans underwrite the work; creator keeps every sat.',

  // Creator guidelines
  'creators.guidelinesMetaDesc': 'How to use KATOA as a creator — tips, wishlists, DMs, and safety.',
  'creators.guidelinesSubtitle': 'Keep 100% of earnings. Stay sovereign. Stay human.',
  'creators.guidelinesRelated': 'Related links',
  'guidelines.1.title': 'You own the relationship',
  'guidelines.1.body':
    'Fans pay you — Lightning address, zaps, or product purchases. KATOA never holds funds or takes a cut.',
  'guidelines.2.title': 'You set the content boundaries',
  'guidelines.2.body':
    'SFW or adult-oriented — be clear in your bio. Follow the law where you and your audience live. No CSAM, no non-consensual imagery, no scams.',
  'guidelines.3.title': 'Wishlists are promises you keep',
  'guidelines.3.body':
    'If fans buy products or fund goals, communicate. Update progress. Mark items funded when appropriate.',
  'guidelines.4.title': 'Private messages are opt-in',
  'guidelines.4.body':
    'Enable Messages only if you want DMs. You can turn them off anytime. Never ask fans for seed phrases or remote wallet access.',
  'guidelines.5.title': 'No impersonation',
  'guidelines.5.body':
    'Use your identity. Linking Nostr (NIP-07) strengthens trust. Do not impersonate brands or other people.',

  // Security body
  'security.nonCustodial.title': 'Non-custodial by design',
  'security.nonCustodial.body':
    'KATOA never holds your Bitcoin. Supporters send sats to addresses and Lightning destinations you control. If our servers go offline, your money is still in your wallet.',
  'security.keys.title': 'Keys stay with you',
  'security.keys.body':
    'Account login uses email/OAuth (or demo mode). Optional Nostr keys stay in your browser extension or device. We do not store seed phrases or private keys.',
  'security.minimalData.title': 'Minimal data',
  'security.minimalData.body':
    'We store what is needed to run wishlists and auth. See Privacy for details. Prefer Lightning addresses and public npubs over personal identifiers when you can.',
  'security.host.title': 'What we host',
  'security.host.body':
    'The web app (Cloudflare Pages), optional Supabase for profiles/wishlists, and analytics that do not require bank-grade surveillance. Payment settlement happens on Bitcoin / Lightning.',
  'security.openSource.title': 'Open source & proof',
  'security.openSource.body':
    'Frontend is MIT-licensed on GitHub. Architecture and fee claims are public. Report security issues via GitHub; critical findings may earn sats when a bounty is funded.',
  'security.safeHarbour.title': 'Safe harbour',
  'security.safeHarbour.body':
    'KATOA is educational software. Nothing here is legal, tax, or investment advice. You are responsible for compliance in your jurisdiction.',
  'security.privacyPolicy': 'Privacy policy',
  'security.viewSource': 'View source on GitHub',

  // Pitch chrome + slide titles
  'pitch.aria': 'KATOA pitch deck',
  'pitch.slide0.eyebrow': 'Give A Bit · Bitcoin Sovereignty · FOSS',
  'pitch.slide0.title': 'KATOA',
  'pitch.slide0.subtitle': "Keep All That's Owed Always",
  'pitch.slide0.statFee': 'Platform fee',
  'pitch.slide0.statCost': 'Monthly cost',
  'pitch.slide0.statKeep': 'You keep',
  'pitch.slide1.eyebrow': 'The broken creator economy',
  'pitch.slide1.title': 'Platforms take 5–20% — and your freedom',
  'pitch.slide2.eyebrow': 'The KATOA answer',
  'pitch.slide2.title': 'Infrastructure, not rent extraction',
  'pitch.slide3.eyebrow': 'Radical transparency',
  'pitch.slide3.title': 'Let the math close the deal',
  'pitch.slide3.platform': 'Platform',
  'pitch.slide3.fees': 'Fees',
  'pitch.slide3.payout': 'Payout',
  'pitch.slide4.eyebrow': 'Product path',
  'pitch.slide4.title': 'Zero platform fee. Honest feature status.',
  'pitch.slide5.eyebrow': 'Audience',
  'pitch.slide5.title': 'Built for creators who refuse to pay rent',
  'pitch.slide6.eyebrow': 'Under the hood',
  'pitch.slide6.title': 'Real product. Real stack.',
  'pitch.slide7.eyebrow': 'Give A Bit ecosystem',
  'pitch.slide7.title': 'Private money. Feel-good giving.',
  'pitch.slide8.eyebrow': 'Next step',
  'pitch.slide8.title': 'Ready to keep 100%?',

  // Landing hero featured skate shot
  'home.shot.title': 'Skateboard Park for Medellín Youth',
  'home.shot.description':
    'Transform lives through skateboarding. Building a safe community space where 500+ youth can skate, learn, and grow.',
  'home.shot.satsRaised': '${n} sats raised',
  'home.shot.ofGoal': 'of ${n} sats goal',
  'home.shot.sendGift': 'Send a gift',
  'home.shot.fundedPct': '${pct}% funded',
  'home.shot.coverAlt': '${title} cover',

  // Creator verticals
  'verticals.model.label': 'Model / influencer',
  'verticals.model.blurb': 'Tips, exclusive drops, shoot funds, and fan wishlists — keep 100%.',
  'verticals.fitness.label': 'Fitness & wellness',
  'verticals.fitness.blurb': 'Program launches, gym gear, retreats. Supporters fund your next PR.',
  'verticals.meals.label': 'Meal planner / chef',
  'verticals.meals.blurb': 'Cookbook print runs, kitchen tools, recipe video days.',
  'verticals.golf.label': 'Golf & sports',
  'verticals.golf.blurb': 'Tournament entries, clubs, travel. Fans back the bag — not the platform.',
  'verticals.lifestyle.label': 'Lifestyle & moms',
  'verticals.lifestyle.blurb': 'Family content, home projects, everyday creator tips with dignity.',
  'verticals.music.label': 'Music & performance',
  'verticals.music.blurb': 'Albums, merch, tour legs — patrons fund art, not fees.',
  'verticals.education.label': 'Coach & educator',
  'verticals.education.blurb': 'Courses, workshops, classroom supplies. Teach freely, earn fully.',
  'verticals.creator.label': 'Any creator',
  'verticals.creator.blurb': 'If you create value, KATOA is your tip jar + wishlist. Zero cut through 31 Dec 2026.',

  // Fee comparison
  'fee.bestValue': 'BEST VALUE',
  'fee.monthlyFees': 'Monthly Fees',
  'fee.youKeep': 'You Keep',
  'fee.lostPct': '-${pct}% lost',
  'fee.yours': '100% yours',
  'fee.trueCost': 'The True Cost of Platform Fees',
  'fee.trueCostSub': "See how much you're losing to competitors' fees. KATOA keeps it simple: 0% through 31 Dec 2026.",
  'fee.monthlyGoal': "What's your monthly project goal?",
  'fee.currency': 'Currency',
  'fee.convertedUsd': 'Amounts converted to USD for comparison',
  'fee.earningsAria': 'Monthly earnings amount',
  'fee.saveMonth': 'Save ${amount} per month',
  'fee.saveYear': "That's ${amount} per year back in your pocket with KATOA.",
  'fee.whatWouldYouDo': 'What would you do with that money?',
  'fee.startKeeping': 'Start Keeping 100% Today',
  'fee.countries': '195+ Countries',
  'fee.throneCountries': 'Throne: ~10 countries with 0% fees',
  'fee.katoaCountries': 'KATOA: All countries, 0% through 31 Dec 2026',
  'fee.instant': 'Fast settlement (Roadmap: In progress)',
  'fee.onlyfansPayout': 'OnlyFans: 7-day rolling payout',
  'fee.katoaLightning': 'KATOA: Instant Lightning Network (with Lightning receive — see Roadmap)',
  'fee.privacy': 'True Privacy',
  'fee.competitorsData': 'Competitors: Server-based data collection',
  'fee.katoaZk': 'KATOA: Zero-knowledge proofs (roadmap)',
  'fee.tableCaption': 'Platform fee comparison for monthly earnings',
  'fee.colPlatform': 'Platform',
  'fee.colFees': 'Monthly fees',
  'fee.colKeep': 'You keep',
  'fee.graphAria':
    'How much of every dollar you keep, by platform: KATOA keeps 100%, Linktree 91%, Throne 90%, OnlyFans 80%',
  'fee.graphTip':
    'Hover a bar to compare how much of each dollar actually reaches you. KATOA is the only platform where 100% is yours — every other platform takes a cut before you ever see it.',
  'fee.barTip': '${platform}: you keep ${pct}% of every dollar.',
  'fee.barTipKatoa': '${platform}: you keep ${pct}% of every dollar — zero fees through 31 Dec 2026.',
  'fee.tipKatoa':
    '0% platform fees through 31 Dec 2026. Built on Bitcoin Lightning Network. Every dollar you earn is yours to keep. No hidden costs, no platform taxes, no surprise charges.',
  'fee.tipOnlyFans':
    'OnlyFans charges 20% platform fee on all earnings. If you earn $10,000, they take $2,000. Plus payment processing fees and currency conversion costs.',
  'fee.tipThrone':
    'Throne charges 10% platform fee plus 2.9% + $0.30 payment processing. Only available in ~10 countries with 0% promotional rate. Requires bank account and KYC verification.',
  'fee.tipLinktree':
    'Linktree charges 9-10% in fees plus $40/month subscription for Commerce features. Payment processing fees vary by region. Requires bank account.',
  'fee.feesTipKatoa':
    'Zero platform fees through 31 Dec 2026. KATOA never takes a cut of your earnings. No monthly subscriptions. No transaction fees. No payment processing fees. What you earn is what you keep.',
  'fee.feesTipOnlyFans':
    'OnlyFans takes 20% of everything you earn. From ${earned}, they extract ${fees}. This applies to subscriptions, tips, PPV, and all other revenue.',
  'fee.feesTipThrone':
    'Throne charges 10% platform fee on all transactions. From ${earned}, they take ${fees}. Additional payment processing fees apply.',
  'fee.feesTipLinktree':
    'Linktree charges approximately 9% in fees plus $40/month subscription. From ${earned}, total cost is ${fees}. Payment processor fees vary by location.',
  'fee.keepTipKatoa':
    "Your actual take-home: ${net} from ${earned} earned. That's 100% of your earnings. Fast settlement via the Bitcoin Lightning Network once receive ships.",
  'fee.keepTipOther':
    'Your actual take-home after ${platform} takes their cut: ${net} from ${earned} earned. You lose ${fees} to platform fees. Payouts take 7-14 days.',

  // Footer leftovers
  'footer.movement':
    'A movement to democratize giving using Bitcoin—anyone with a smartphone can support causes worldwide, instantly, privately, and directly. Zero platform fees through 31 Dec 2026 — absorbed by Give A Bit.',
  'footer.acronym': "Keep All That's Owed Always",
  'footer.openRoles': 'Open Roles',
  'footer.giveABit': 'A Give A Bit project',
  'footer.madeWith': 'Made with',
  'footer.and': 'and',
  'footer.donateTitle': 'Support FOSS Development',
  'footer.donateSubtitle': 'Help keep KATOA free and open-source',
  'footer.mainChain': 'Bitcoin Main Chain',
  'footer.copy': 'Copy',
  'footer.copied': 'Copied',
  'footer.tapEnlarge': 'Tap to enlarge',
  'footer.donateClose': 'Close donation drawer',
  'footer.donateExpand': 'Expand donation QR code',
  'footer.donateQrAlt': 'Donation QR',
  'footer.donateFund':
    'Your sats fund free tools for the Bitcoin community.',

  // Thank-you page — the real end of every conversion flow.
  'thankyou.metaTitle': 'Thank you — what happens next | KATOA',
  'thankyou.metaDesc':
    'Your action completed on KATOA. Here is exactly what happened and the three steps that come next — confirmed by email, wallet, then your first wishlist.',
  'thankyou.default.title': 'Thank you — that worked.',
  'thankyou.default.lead':
    'Your action went through and nothing else is required from you right now. Below is what happens next and where to go from here.',
  'thankyou.signup.title': 'Thank you — your account is created.',
  'thankyou.signup.lead':
    'Welcome to KATOA. We sent a confirmation link to the email address you used — tap it and your account is live. No KYC, no card, no platform fee through 31 Dec 2026.',
  'thankyou.contact.title': 'Thank you — your message is on its way.',
  'thankyou.contact.lead':
    'We received your message and a copy was placed on your clipboard as a backup. A human on the KATOA team replies within one business day.',
  'thankyou.support.title': 'Thank you — your sats keep KATOA free.',
  'thankyou.support.lead':
    'Your support funds free, open-source tools for the Bitcoin community. No intermediary touched it, and none ever will.',
  'thankyou.gift.title': 'Thank you — your gift is sent.',
  'thankyou.gift.lead':
    'Your Lightning payment settled peer-to-peer. The creator receives it directly; KATOA never custodies the money and takes 0%.',
  'thankyou.nextTitle': 'What happens next',
  'thankyou.step1.title': 'Check your inbox',
  'thankyou.step1.body':
    'Confirm your email address so nobody else can claim your username. The link works for 24 hours.',
  'thankyou.step2.title': 'Add a Lightning address',
  'thankyou.step2.body':
    'Settings → Payouts. Paste a Lightning address (Phoenix, Wallet of Satoshi, Muun, or your own LND) so gifts reach you directly.',
  'thankyou.step3.title': 'Publish your first wishlist',
  'thankyou.step3.body':
    'Create a wishlist, set sat prices, and share the link. Supporters fund items over Lightning in seconds once receive ships.',
  'thankyou.cta.explore': 'Explore projects',
  'thankyou.cta.dashboard': 'Go to my dashboard',
  'thankyou.helpPrefix': 'Stuck or something looks wrong? Email us:',
};
